'use strict';

const filter = (function() {
  const filterRadios = document.querySelectorAll('.input-filter-radio');
  const clearFilterClass = '.button--filters-clear';
  const hiddenClass = 'hidden';
  const focusedClass = 'js-color-wheel-focused';
  const selectedClass = 'is-selected';
  const visibleClass = 'is-visible';
  /**
   *
   * @param e - change event
   */
  function handleRadioUpdates(e) {
    const target = e.target;
    // checked radio
    if (target.checked) {
      target.nextElementSibling.style.opacity = 1;
      // color PCP
      if (target.nextElementSibling.querySelector(clearFilterClass)) {
        target.nextElementSibling
          .querySelector(clearFilterClass)
          .classList.remove(hiddenClass);
      }
    }
    // unchecked radios
    const uncheckedRadios = target.parentElement.querySelectorAll(
      'input[type="radio"]:not(:checked) + label'
    );
    [...uncheckedRadios].forEach(unchecked => {
      if (target === unchecked) return;
      unchecked.style.opacity = 0.4;
      // color PCP
      if (unchecked.querySelector(clearFilterClass)) {
        unchecked.querySelector(clearFilterClass).classList.add(hiddenClass);
      }
    });
  }
  function uncheckRadioInputs() {
    [...filterRadios].forEach(radio => {
      radio.checked = false;
      radio.nextElementSibling.style.opacity = 1;
      // color PCP application filter close
      if (radio.nextElementSibling.querySelector(clearFilterClass)) {
        radio.nextElementSibling
          .querySelector(clearFilterClass)
          .classList.add(hiddenClass);
      }
    });
  }
  function handleClearFilterSubButton(e) {
    //uncheck and reset opacity to all in family
    e.preventDefault();
    e.stopPropagation();
    const inputs = this.parentNode.parentNode.querySelectorAll(
      '.input-filter-radio'
    );
    [...inputs].forEach(radio => {
      radio.checked = false;
      radio.nextElementSibling.style.opacity = 1;
    });
    //hidden button
    this.classList.add(hiddenClass);
  }
  function clearFilters() {
    console.log('clearing');
    const colorWheel = document.getElementById('color-wheel');
    uncheckRadioInputs();
    // color PCP color wheel
    if (colorWheel !== null && colorWheel.classList.contains(focusedClass)) {
      const selectedColorWheelSlice = colorWheel.querySelector(
        '.color-slice.is-selected'
      );
      const visibleColorWheelDot = colorWheel.querySelector(
        '.color-slice__dot.is-visible'
      );
      const colorWheelText = colorWheel.querySelector('.wheel-text');
      colorWheel.classList.remove(focusedClass);
      selectedColorWheelSlice.classList.remove(selectedClass);
      visibleColorWheelDot.classList.remove(visibleClass);
      colorWheelText.innerHTML = '';
    }
  }
  function init() {
    const filtersModal = document.getElementById('modal-colors-filters');
    const clearFilterButtons = document.querySelectorAll('.js-clear-filter');
    const clearFilterSubButtons = document.querySelectorAll(
      '.js-sub-clear-filter'
    );
    const modalBackground = document.querySelector(
      '#modal-colors-filters .modal__bg'
    );
    [...filterRadios].forEach(radio =>
      radio.addEventListener('change', handleRadioUpdates)
    );
    [...clearFilterButtons].forEach(button =>
      button.addEventListener('click', clearFilters)
    );
    [...clearFilterSubButtons].forEach(button =>
      button.addEventListener('click', handleClearFilterSubButton)
    );
    // if (modalBackground && filtersModal) {
    //   modalBackground.addEventListener('click', clearFilters);
    //   filtersModal.addEventListener('keydown', function(e) {
    //     if (e.keyCode === 27) clearFilters();
    //   });
    // }
  }
  return {
    init,
  };
})();

export default filter;
